.vendor-lead-step-condition__container {
  flex: 1;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;

  gap: 16px;

  & .ant-tabs-nav {
    background-color: #F2F3F5;
    margin: 0 -100%;
    padding: 0 100%;
  }
}

.vendor-lead-step-condition__container .vendor-lead-step-condition__controls {
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;

  gap: 32px;
}

.vendor-lead-step-condition__container .vendor-lead-step-condition__sds-files {
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;

  gap: 16px;

  padding: 24px 0 0;
}

.vendor-lead-step-condition__container .vendor-lead-step-condition__add-sds-file__button {
  cursor: pointer;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  gap: 8px;

  width: 320px;
  height: 180px;
  border-radius: 8px;
  border: 1px dashed #CCCFD8;

  &:hover {
    border-color: #0082F9;
  }
}

.vendor-lead-step-condition__container  .vendor-lead-step-condition__add-photo__text {
  color: #0082F9;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}

.vendor-lead-step-condition__container .vendor-lead-step-condition__info-icon {
  padding: 0 10px;
  border-radius: 50%;
  border: 1px solid #DADADA;

  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.vendor-lead-step-condition__container .vendor-lead-step-condition__error-icon {
  color: var(--color-danger-medium);
  border-color: var(--color-danger-medium);
}

.vendor-lead-step-condition__container .vendor-lead-step-condition__info-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;

  & a {
    text-decoration: underline dashed;
  }
}

.vendor-lead-step-condition__container .vendor-lead-step-condition__error-message {
  position: relative;
}


@media screen and (width <= 640px) {
  .vendor-lead-step-condition__container {
    & .ant-tabs-nav {
      margin: 0 -16px;
      padding: 0 16px;
    }
  }

  .vendor-lead-step-condition__container .vendor-lead-step-condition__controls {
    flex-flow: column nowrap;
    align-items: stretch;
  }

  .vendor-lead-step-condition__container .vendor-lead-step-condition__add-sds-file__button {
    width: unset;
  }
}


